import { render, staticRenderFns } from "./IletisimForm.vue?vue&type=template&id=faa20fc0"
import script from "./IletisimForm.vue?vue&type=script&lang=ts"
export * from "./IletisimForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports